import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DefaultTextField } from '../../../TextFields';
import { DefaultInputLabel } from '../../../InputLabels';
import {
  common,
  KINDOFBID,
  VALID_RELATIONS
} from './../../../../data/constants';
import { getHoursAndMinutesForDuration } from './helpers.js';
import { useLanguage } from '../../../../context/LanguageContext';

import { withStyles } from '@material-ui/core';

export const TimeInput = withStyles({
  root: {
    width: '60px'
  }
})(DefaultTextField);

class DurationInterval extends Component {
  constructor(props) {
    super(props);
    this.parameterSequence = props.parameter.sequence;
    this.hoursId = `${props.hourName}-${this.parameterSequence}`;
    this.minutesId = `${props.minuteName}-${this.parameterSequence}`;

    [this.parameterMaxAllowedHours] = getHoursAndMinutesForDuration(
      props.parameter.maxValue
    );

    let hours = 0;
    let minutes = 0;
    const maxHours = this.parameterMaxAllowedHours;
    let maxMinutes = 0;

    if (props.value.parameterValues) {
      // User is editing the request
      const storedValueForParameter = Number(
        props.value?.parameterValues[this.parameterSequence - 1]?.value
      );
      [hours, minutes] = getHoursAndMinutesForDuration(storedValueForParameter);
    } else {
      // New request
      const defaultValue = Number(props.parameter.defaultValue);
      [hours, minutes] = getHoursAndMinutesForDuration(defaultValue);
    }

    // When hours hits the max allowed value,
    // user is not allowed to enter minutes
    maxMinutes = hours < maxHours ? 59 : 0;

    const { selectedRelation } = this.props;
    const renderParameter = this.parameterShouldRender(selectedRelation);
    this.state = {
      renderParameter,
      maxHours,
      maxMinutes,
      hours,
      minutes
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { selectedRelation } = nextProps;
    const renderParameter = this.parameterShouldRender(selectedRelation);
    this.setState({ renderParameter });
  }

  parameterShouldRender = selectedRelation => {
    const { preferenceOptionId, parameter, setHiddenParameter, removeHiddenParameter } = this.props;
    let renderParameter = true;
    if (KINDOFBID.LINECREDIT_PREFERENCE_ID.includes(preferenceOptionId)) {
      if (
        selectedRelation === VALID_RELATIONS.LESS_THAN &&
        parameter.sequence === 1
      ) {
        renderParameter = true;
        removeHiddenParameter(parameter.parameterId);

      } else if (
        selectedRelation === VALID_RELATIONS.GREATER_THAN &&
        parameter.sequence === 1
      ) {
        renderParameter = true;
        removeHiddenParameter(parameter.parameterId);

      } else if (selectedRelation === VALID_RELATIONS.BETWEEN) {
        renderParameter = true;
        removeHiddenParameter(parameter.parameterId);

      } else {
        setHiddenParameter(parameter.parameterId);
        renderParameter = false;
      }
    }

    return renderParameter;
  };

  handleOnChange = event => {
    const enteredValue = Number(event.target.value);
    event.target.value = enteredValue;

    const timeSegment = event.target.name.slice(5, 9);
    const newState = { ...this.state };
    const { setSelectedParameterValues, parameter } = this.props;

    if (timeSegment === 'hour') {
      if (enteredValue < this.parameterMaxAllowedHours) {
        newState.hours = enteredValue;
        newState.maxMinutes = 59;
      } else {
        newState.hours = this.parameterMaxAllowedHours;
        newState.minutes = 0;
        newState.maxMinutes = 0;
      }
    } else if (timeSegment === 'minu') {
      if (enteredValue < this.state.maxMinutes) {
        newState.minutes = enteredValue;
      } else {
        newState.minutes = this.state.maxMinutes;
      }
    }

    this.setState(newState, () => {
      const { hours, minutes } = this.state;
      setSelectedParameterValues(
        this.parameterSequence - 1,
        hours * 60 + minutes,
        parameter.parameterId
      );
    });
  };

  handleOnKeyPress = event => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  };

  render() {
    return (
      this.state.renderParameter && (
        <div>
          <DefaultInputLabel>{this.props.label}</DefaultInputLabel>
          <div>
            <div className={this.props.hourClassName}>
              <TimeInput
                name={this.hoursId}
                value={this.state.hours}
                fullWidth
                type='number'
                onKeyPress={this.handleOnKeyPress}
                onChange={e => this.handleOnChange(e)}
                inputProps={{
                  max: this.state.maxHours,
                  min: 0
                }}
                step={this.props.hourStep}
                style={{ zIndex: 2104 }}
              />
            </div>
            <div className={this.props.minuteClassName}>
              <TimeInput
                name={this.minutesId}
                floatingLabelText={' '}
                value={this.state.minutes}
                fullWidth
                type='number'
                inputProps={{
                  max: this.state.maxMinutes,
                  min: 0
                }}
                onKeyPress={this.handleOnKeyPress}
                onChange={e => this.handleOnChange(e)}
                step={this.props.minuteStep}
                style={{ zIndex: 2104 }}
              />
            </div>
          </div>
        </div>
      )
    );
  }
}

DurationInterval.propTypes = {
  description: PropTypes.string,
  hourName: PropTypes.string.isRequired, // String id-react
  hourHintText: PropTypes.any, // Placeholder
  hourStep: PropTypes.number.isRequired, // Step 1-1 15-15
  hourClassName: PropTypes.string, // Class for texfield
  minuteName: PropTypes.string.isRequired, // String id-react
  minuteHintText: PropTypes.any, // Placeholder
  minuteStep: PropTypes.number.isRequired, // Step Minutes
  minuteClassName: PropTypes.string, // Class for texfield
  parameter: PropTypes.object,
  value: PropTypes.object,
  preferenceOptionId: PropTypes.number,
  selectedRelation: PropTypes.string,
  setHiddenParameter: PropTypes.func.isRequired,
  removeHiddenParameter: PropTypes.func.isRequired,
  setSelectedParameterValues: PropTypes.func.isRequired,
  label: PropTypes.string
};

DurationInterval.defaultProps = {
  description: '',
  hourname: '',
  hourHintText: '',
  minuteName: '',
  minuteHintText: '',
  hourClassName: '',
  minuteClassName: '',
  parameter: {},
  value: {},
  preferenceOptionId: 0,
  selectedRelation: '',
  label: ''
};

function DurationIntervalWrapper(props) {
  const { labels } = useLanguage();
  return <DurationInterval {...props} label={labels.INTERVAL_DURATION} />;
}

export default DurationIntervalWrapper;
